import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Checkbox, Form, Input } from 'antd';
import settings from 'settings';
import {
  getKey, getLabel, getNameLabel, getSelect, getSelects
} from 'library/helpers';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';
import { FormWrapper } from 'components/Page';
import ExtendedSelect from 'components/extendedSelect';
import TagSelector from 'components/tagSelector/tag-selector';

const { TextArea } = Input;

const FormItem = Form.Item;
const mapStateToProps = state => ({
  statusInFlight: state.api.actionStatusList.inFlight,
  status: state.api.actionStatusList.data.results,
  prioritiesInFlight: state.api.actionPriorities.inFlight,
  priorities: state.api.actionPriorities.data.results,
  users: state.api.peopleData.data.results,
  userInFlight: state.api.peopleData.inFlight,
  notificationTypes: state.api.notificationTypes.data.results,
  notificationTypesInFlight: state.api.notificationTypes.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadStatus(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.actionStatusList.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadPriorities(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.actionPriorities.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadUsers(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'last_name',
      desc: false
    }];
    const filters = [{
      id: 'is_active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'last_name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.peopleData.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadNotificationTypes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.notificationTypes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    name,
    default_notification_types,
    default_assignees,
    default_priority,
    default_status,
    active
  } = dataSource;

  return {
    name: Form.createFormField({ value: name }),
    default_assignees: Form.createFormField({ value: getSelects(default_assignees, ['last_name', 'first_name']) }),
    default_status: Form.createFormField({ value: getSelect(default_status) }),
    default_priority: Form.createFormField({ value: getSelect(default_priority) }),
    default_notification_types: Form.createFormField({ value: getSelects(default_notification_types) }),
    active: Form.createFormField({ value: active })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin,
  checkboxFormItemLayout,
  form, dataSource,
  inputFormItemLayout,
  loadNotificationTypes,
  loadPriorities,
  loadStatus,
  loadUsers,
  notificationTypes,
  priorities,
  status,
  users,
  notificationTypesInFlight,
  prioritiesInFlight,
  statusInFlight,
  usersInFlight
}) => {
  const { getFieldDecorator } = form;
  const {
    name,
    default_assignees,
    default_priority,
    default_status,
    default_user_assignee_tags,
    default_notification_types,
    default_description,
    active
  } = dataSource;
  const readonly = !canAdmin;

  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the name.'
            }]
          })(<Input disabled={readonly} />)
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Default Status">
        {getFieldDecorator('default_status', {
          initialValue: default_status,
          rules: [
            {
              required: true,
              message: 'Please select a Default Status.'
            }
          ]
        })(
          <ExtendedSelect
            fetching={statusInFlight}
            placeholder="Select status"
            optionKey={getKey}
            optionLabel={getLabel}
            disabled={readonly}
            onSearch={loadStatus}
            onFocus={loadStatus}
            dataSource={status}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Default Priority">
        {getFieldDecorator('default_priority', {
          initialValue: default_priority,
          rules: [
            {
              required: true,
              message: 'Please select a Default Priority.'
            }
          ]
        })(
          <ExtendedSelect
            fetching={prioritiesInFlight}
            placeholder="Select priority"
            optionKey={getKey}
            optionLabel={getLabel}
            disabled={readonly}
            onSearch={loadPriorities}
            onFocus={loadPriorities}
            dataSource={priorities}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Default Assignees">
        {getFieldDecorator('default_assignees', {
          initialValue: default_assignees
        })(
          <ExtendedSelect
            mode="multiple"
            fetching={usersInFlight}
            placeholder="Select assignees"
            optionKey={getKey}
            optionLabel={getNameLabel}
            disabled={readonly}
            onSearch={loadUsers}
            onFocus={loadUsers}
            dataSource={users}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Default Tags">
        {getFieldDecorator('default_user_assignee_tags', {
          initialValue: default_user_assignee_tags && default_user_assignee_tags.length ? default_user_assignee_tags.map(item => ({
            key: item.id || item.key,
            label: item.qualified_name || item.label
          })) : undefined
        })(
          <TagSelector
            theme="user"
            placeholder="Select tags"
            tagSelectorReducerKey={REDUCER_KEY.userCollectionValues}
            disabled={readonly}
            maxTagCount={5}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Default Notification Types">
        {getFieldDecorator('default_notification_types', {
          initialValue: default_notification_types,
          rules: [
            {
              required: true,
              message: 'Please select a Default Notification Type.'
            }
          ]
        })(
          <ExtendedSelect
            mode="multiple"
            fetching={notificationTypesInFlight}
            placeholder="Select notifications"
            optionKey={getKey}
            optionLabel={getLabel}
            disabled={readonly}
            onSearch={loadNotificationTypes}
            onFocus={loadNotificationTypes}
            dataSource={notificationTypes}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Default Description">
        {getFieldDecorator('default_description', {
          initialValue: default_description,
          rules: [
            {
              required: true,
              message: 'Please select a Default Description.'
            }
          ]
        })(
          <TextArea
            rows={4}
          />
        )}
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('active', {
            initialValue: active,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Active
            </Checkbox>
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  loadNotificationTypes: PropTypes.func,
  loadStatus: PropTypes.func,
  loadPriorities: PropTypes.func,
  loadUsers: PropTypes.func,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  notificationTypes: PropTypes.array,
  priorities: PropTypes.array,
  prioritiesInFlight: PropTypes.bool,
  status: PropTypes.array,
  notificationTypesInFlight: PropTypes.bool,
  statusInFlight: PropTypes.bool,
  usersInFlight: PropTypes.bool,
  users: PropTypes.array
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  loadStatus() {
  },
  loadNotificationTypes() {
  },
  loadPriorities() {
  },
  loadUsers() {
  },
  onFieldsChange() {
  },
  onValuesChange() {
  },
  notificationTypes: [],
  priorities: [],
  notificationTypesInFlight: false,
  prioritiesInFlight: false,
  status: [],
  statusInFlight: false,
  usersInFlight: false,
  users: []
};

const ActionTypeInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default connect(mapStateToProps, mapDispatchToProps)(ActionTypeInput);
